import React from 'react'
import { Container, Text, TextVersion } from './styles'

type Props = {
  text: string
  textVersion: string
  background?: 'default' | 'light'
}

const Footer: React.FC<any> = ({
  text,
  textVersion,
  background,
}: Props): JSX.Element => {
  return (
    <Container className={background}>
      <Text> {text} </Text>
      <TextVersion> {textVersion} </TextVersion>
    </Container>
  )
}

export default Footer
